import React from "react";
import logosmall from "../../assets/logosmall.png";
import { Grid } from "@mui/material";

export default function Home() {
  return (
    <>
      <Grid sx={{
         padding: "10px",
         minWidth: "75%",
         display: "flex",
         marginTop: "70px",
         justifyContent: "center",
      }}>
        <img src={logosmall} style={{ maxWidth: "40%" }} alt="logosmall" />
      </Grid>
    </>
  );
}
